// 로그를 기록한 실제 시각과 지금의 실제 시각 차이(밀리초) → "N분 M초 전". 게임 화면의 시계를 다시 읽지 않고 컴퓨터 시각만으로 센다.
export function formatAgo(diffMs) {
  const totalSec = Math.max(0, Math.floor(diffMs / 1000));
  const minutes = Math.floor(totalSec / 60);
  const seconds = totalSec % 60;
  return minutes > 0 ? `${minutes}분 ${seconds}초 전` : `${seconds}초 전`;
}
